/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormRecordReadonlyTextFieldComponent } from '../../admin/form/form-record/fields/readonly/text/form-record-readonly-text-field.component';
/* eslint-enable */

export class FormRecordReadonlyTextFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordReadonlyTextFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
